module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    style: (_vm.cardStyle)
  }, [_c('md-card-media', [_c('div', {
    staticClass: "plugin-img"
  })]), _vm._v(" "), _c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.desc))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4d4f5892"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/PluginCard.vue
// module id = 347
// module chunks = 1